import { useMutation } from '@tanstack/react-query'

import API from '@shared/services/src/API'

export function useGetMessage() {
  return useMutation({
    mutationFn: ({ conversationId, messageId }) => API.conversations.id(conversationId).messages.id(messageId).details(),
  })
}
